import React from "react";

const Alert = ({ style }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="34.083"
      height="32"
      viewBox="0 0 34.083 32"
      style={style}
      stroke="currentColor"
    >
      <g id="Raggruppa_385" transform="translate(-52.407 -416.89)">
        <path
          id="Tracciato_92"
          d="M56.093,447.889H82.967a2.522,2.522,0,0,0,2.22-3.72L71.751,419.217a2.523,2.523,0,0,0-4.444,0L53.871,444.169a2.523,2.523,0,0,0,2.221,3.72Z"
          transform="translate(0)"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          id="Tracciato_93"
          d="M69.116,428.136l.453,9.619.452-9.615a.453.453,0,0,0-.432-.473h-.025a.452.452,0,0,0-.448.457Z"
          transform="translate(-0.039 -0.025)"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          id="Tracciato_94"
          d="M69.566,444.084a1.577,1.577,0,1,1,1.577-1.577A1.577,1.577,0,0,1,69.566,444.084Z"
          transform="translate(-0.036 -0.058)"
        />
      </g>
    </svg>
  );
};

export default Alert;
